import { createReducer } from "@reduxjs/toolkit";
import {
  dOrdersAddProductToCartAC,
  dOrdersCheckedAllItemAC,
  dOrdersCheckedItemAC,
  dOrdersClearCartItemAC,
  dOrdersClearDetailItemAC,
  dOrdersClearFiltersAC,
  dOrdersClearProductFiltersAC,
  dOrdersDeleteProductFromCartItemAC,
  dOrdersProductsSetPaginationAC,
  dOrdersSetCartItemAC,
  dOrdersSetCountForProductInCartItemAC,
  dOrdersSetDataAC,
  dOrdersSetDetailItemAC,
  dOrdersSetDetailItemFullAC,
  dOrdersSetDetailProductAC,
  dOrdersSetDiscountInCartItemAC,
  dOrdersSetFilteredProductsAC,
  dOrdersSetFiltersAC,
  dOrdersSetItemsForPageAC,
  dOrdersSetMarkLabelForProductInCartItemAC,
  dOrdersSetPageNumberAC,
  dOrdersSetPaginationAC,
  dOrdersSetPriceForProductInCartItemAC,
  dOrdersSetProductFiltersAC,
  dOrdersSetSaleDetailItemC,
  dOrdersSetSelectedStoreAC,
  dOrdersSetServicePaymentInCartItemAC,
} from "model/dashboardOrders/dOrdersActionCreators";
import {logoutAC, resetReducers} from "model/system/systemActionCreators";
import { typePagination } from "model/system/constants";
import {
  IdProductsStateDataItem,
  typeProductsFilters,
} from "model/dashboardProducts/dProductsReducer";
import { IdUsersStateDataItem } from "model/dashboardUsers/dUsersReducer";
import { typeFullSalesItem } from "model/dashboardSales/dSalesReducer";
import { IdStoresStateDataItem } from "model/dashboardStores/dStoresReducer";

// Type

type typeProductOrder = {
  barcodes: string[];
  commissionTIN: string | undefined;
  id: string;
  isDecimalUnits: boolean;
  name: string;
  psid: string | null;
  unitMeasurement: string;
  marked?: boolean;
};

//  type for create order
export type typeOrdersProductItem = {
  amount: number;
  discountAmount?: number;
  labels: string[] | null; // this is old version
  markedLabels?: string[] | null; // this is right
  marked: boolean;
  price: number;
  product: typeProductOrder | Omit<IdProductsStateDataItem, "checked">;
  tax?: number;
  productName?: string;
};

export type typeOrderedProductInOrder = {
  id: string;
  customTotal: number | null;
  productName: string;
  unitCode: number | null;
  packageCode: number | null;
  commissionPINFL: string | null;
  commissionTIN: string | number;
  psid: string;
  barcodes: string[];
  productOwnerType: IdProductsStateDataItem["productOwnerType"];
  amount: number;
  discountAmount?: number;
  labels: string[] | null; // this is old version
  markedLabels?: string[] | null; // this is right
  marked: boolean;
  price: number;
  product: Omit<IdProductsStateDataItem, "checked">;
  tax?: number;
};

export type typeOrdersItemFull = {
  saleId?: string | null;
  address: string;
  collector?: {
    id: string;
    name: string;
  } | null;
  comment?: string;
  courier?: {
    id: string;
    name: string;
  } | null;
  courierId: string;
  createdBy: string;
  updatedBy?: string;
  userCreated: IdUsersStateDataItem;
  userUpdated: IdUsersStateDataItem;
  customerName: string;
  dateCreated: string;
  dateUpdated: string;
  discount: {
    isInPercents: boolean;
    value: number;
  };
  id: string;
  number: number;
  payments: {
    amount: number;
    date: string;
    id: string;
    method: string;
    transactionNumber: number;
  }[];
  phone: string;

  rejectedProducts: typeOrderedProductInOrder[];
  orderedProducts: typeOrderedProductInOrder[];
  acceptedProducts: typeOrderedProductInOrder[];

  servicePayment: {
    isInPercents: boolean;
    value: number;
  };
  status: string;

  store: {
    id: string;
    name: string;
  };

  storeId: string;
  externalId: string | null;
};

export type typeOrdersItemSlim = {
  checked: boolean;
  id: string;
  number: number;
  payments: {
    amount: number;
    date: string;
    id: string;
    method: string;
    transactionNumber: number;
  }[];
  phone: string;
  status: string;
  address: string;
  customerName: string;
  comment: string;
  createdBy: string;
  updatedBy: string;
  courierId: string | null;
  collectorId: string | null;
  externalId: string | null;
  store: IdStoresStateDataItem;
  discount: {
    isInPercents: boolean;
    value: number;
  };
  servicePayment: {
    isInPercents: boolean;
    value: number;
  };
  dateCreated: string;
  dateUpdated: string;
  courier: IdUsersStateDataItem;
  userCreated: IdUsersStateDataItem;
  userUpdated: IdUsersStateDataItem;
  sale: {
    id: string;
    date: string;
    amount: number;
    receiptNumber: string;
    payments: {
      id: string;
      date: string;
      paymentInfo: any;
      paymentType: string;
      paymentAmount: number;
      transactionNumber: any;
      paymentTransactionValue: number;
    }[];
  };
};

export type typeOrdersFilters = {
  searchString?: string | null;
  number?: string | number | null;
  status?: string | null;
  client?: string | null;
  courierId?: string | null;
  address?: string | null;
  dateCreated?: {
    from: string | null;
    to: string | null;
  } | null;
  saleId?: string | null;
  externalId?: string | null;
};

export type typeOrdersProductList = {
  commonPrice?: string;
  discount?: {
    isInPercents: boolean; //-> в процентах или валюте
    value: number; // -> значение скидки (если в процентах то 10% = 0.1)
  };
  productList: typeOrdersProductItem[];
  servicePaymentAmount?: {
    isInPercents: boolean; //-> в процентах или валюте
    value: number; // -> значение скидки (если в процентах то 10% = 0.1)
  };
};

export type IdOrdersState = {
  detailSale: typeFullSalesItem | undefined;
  data: typeOrdersItemSlim[];
  detailItem: typeOrdersItemSlim | undefined;
  detailItemFull: typeOrdersItemFull | undefined;
  filters: typeOrdersFilters;
  pagination: typePagination;
  filteredProductList: IdProductsStateDataItem[] | undefined;
  productsFilter: typeProductsFilters | undefined;
  productsPagination: typePagination;
  detailProduct: IdProductsStateDataItem | string | undefined;
  newOrder: typeOrdersProductList | undefined;
  selectedStore:
    | {
        id: string;
        name: string;
      }
    | undefined;
};

// Clean filter object
export const cleanFilterObject: typeOrdersFilters = {
  status: null,
  client: null,
  courierId: null,
  address: null,
  dateCreated: null,
};

// Init state
export const initialState: IdOrdersState = {
  detailSale: undefined,
  data: [],
  detailItem: undefined,
  detailItemFull: undefined,
  filters: cleanFilterObject,
  pagination: {
    pageNumber: 0,
    itemsPerPage: 14,
  },
  productsPagination: {
    pageNumber: 0,
    itemsPerPage: 14,
  },
  filteredProductList: undefined,
  productsFilter: undefined,
  detailProduct: undefined,
  newOrder: {
    discount: {
      isInPercents: true,
      value: 0,
    },
    productList: [],
    servicePaymentAmount: {
      isInPercents: true,
      value: 0,
    },
  },
  selectedStore: undefined,
};

// Reducer
export const DOrdersReducer = createReducer(initialState, (builder) => {
  builder

    // Reducer of set data
    .addCase(dOrdersSetDataAC, (state, action) => {
      state.data = action.payload.dataList;
    })
    // Reducer of set pagination
    .addCase(dOrdersSetPaginationAC, (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload.pagination };
    })

    // Reducer of set items for page pagination
    .addCase(dOrdersSetItemsForPageAC, (state, action) => {
      state.pagination = {
        ...state.pagination,
        pageNumber: 0,
        itemsPerPage: action.payload.itemsForPage,
      };
    })

    // Reducer of set pageNumber pagination
    .addCase(dOrdersSetPageNumberAC, (state, action) => {
      state.pagination.pageNumber = action.payload.pageNumber;
    })

    .addCase(dOrdersProductsSetPaginationAC, (state, action) => {
      state.productsPagination = {
        ...state.productsPagination,
        ...action.payload.pagination,
      };
    })

    // Reducer of set checked item
    .addCase(dOrdersCheckedItemAC, (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload) {
          const newItem = item;
          newItem.checked = !item.checked;
          return newItem;
        } else {
          return item;
        }
      });
    })

    // Reducer of set checked all items
    .addCase(dOrdersCheckedAllItemAC, (state, action) => {
      state.data = state.data.map((item) => {
        const newItem = item;
        newItem.checked = action.payload;
        return newItem;
      });
    })

    // Reducer of set detail item
    .addCase(dOrdersSetDetailItemAC, (state, action) => {
      state.detailItem = state.data.find((item) => item.id === action.payload);
    })

    // Reducer of clear detail item
    .addCase(dOrdersClearDetailItemAC, (state, action) => {
      state.detailItem = initialState.detailItem;
    })

    // reducer set detail full item
    .addCase(dOrdersSetDetailItemFullAC, (state, action) => {
      state.detailItemFull = action.payload;
    })

    // Reducer of set SALE detail item
    .addCase(dOrdersSetSaleDetailItemC, (state, action) => {
      state.detailSale = action.payload;
    })

    // Reducer of clear filtersForm
    .addCase(dOrdersClearFiltersAC, (state) => {
      state.filters = cleanFilterObject;
    })

    // Reducer of set filtersForm
    .addCase(dOrdersSetFiltersAC, (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.pageNumber = 0;
    })

    // Reducer of set selected store
    .addCase(dOrdersSetSelectedStoreAC, (state, action) => {
      state.selectedStore = action.payload.store;
    })

    // Reducer of set data filtered product
    .addCase(dOrdersSetFilteredProductsAC, (state, action) => {
      state.filteredProductList = action.payload.data;
    })

    // Reducer of clear product filters
    .addCase(dOrdersClearProductFiltersAC, (state) => {
      state.productsFilter = undefined;
      state.filteredProductList = undefined;
    })

    // Reducer of set product filters
    .addCase(dOrdersSetProductFiltersAC, (state, action) => {
      state.productsFilter = { ...action.payload, deleted: false };

      state.productsPagination = {
        ...state.productsPagination,
        pageNumber: 0,
      };
    })

    // Reducer of set detail product
    .addCase(dOrdersSetDetailProductAC, (state, action) => {
      state.detailProduct = action.payload;
    })

    // Reducer of set product to  cart
    .addCase(dOrdersAddProductToCartAC, (state, action) => {
      const newProduct = {
        amount: 1,
        labels: action.payload.markLabel ? [action.payload.markLabel] : [],
        marked: action.payload.product.marked,
        price: action.payload.price,
        product: {
          barcodes: action.payload.product.barcodes,
          commissionTIN: action.payload.product.commissionTIN,
          id: action.payload.product.id,
          isDecimalUnits: !action.payload.product.integerUnit,
          name: action.payload.product.name,
          psid: action.payload.product.psid,
          unitMeasurement: action.payload.product.units,
          packageCode: action.payload.product.packageCode || null,
          commissionPINFL: action.payload.product.commissionPINFL || null,
          productOwnerType: action.payload.product.productOwnerType || null,
        },
        tax: action.payload.product.vat,
      };
      if (state.newOrder) {
        const existProduct = state.newOrder.productList.find(
          (item) => item.product.id === action.payload.product.id
        );
        if (existProduct) {
          if (action.payload.product.marked) {
            state.newOrder = {
              ...state.newOrder,
              productList: [...state.newOrder.productList, newProduct],
            };
          }
        } else {
          state.newOrder = {
            ...state.newOrder,
            productList: [...state.newOrder.productList, newProduct],
          };
        }
      } else {
        state.newOrder = {
          discount: {
            isInPercents: true,
            value: 0,
          },
          productList: [newProduct],
          servicePaymentAmount: {
            isInPercents: true,
            value: 0,
          },
        };
      }
    })

    // reducer of delete product from  cart
    .addCase(dOrdersDeleteProductFromCartItemAC, (state, action) => {
      const newProductList = state.newOrder!.productList.filter(
        (product, index) => index !== action.payload.productIndex
      );

      state.newOrder = { ...state.newOrder, productList: newProductList };
    })

    // Reducer of set count of product in cart item
    .addCase(dOrdersSetCountForProductInCartItemAC, (state, action) => {
      const newProductList = state.newOrder!.productList.map((item) => {
        return item.product.id === action.payload.id
          ? {
              ...item,
              amount: action.payload.count,
            }
          : item;
      });
      state.newOrder = { ...state.newOrder, productList: newProductList };
    })

    // Reducer of set price of product in cart item
    .addCase(dOrdersSetPriceForProductInCartItemAC, (state, action) => {
      const newProductList = state.newOrder!.productList.map((item) => {
        return item.product.id === action.payload.id
          ? {
              ...item,
              price: action.payload.price,
            }
          : item;
      });

      // @ts-ignore
      state.newOrder = { ...state.newOrder, productList: newProductList };
    })

    // Reducer of set mark label of product in cart item
    .addCase(dOrdersSetMarkLabelForProductInCartItemAC, (state, action) => {
      const newProductList = state.newOrder!.productList.map((item, index) => {
        return index === action.payload.index
          ? {
              ...item,
              labels: [action.payload.marklabel],
            }
          : item;
      });

      // @ts-ignore
      state.newOrder = { ...state.newOrder, productList: newProductList };
    })

    //Reducer of clear cart
    .addCase(dOrdersClearCartItemAC, (state) => {
      state.newOrder = {
        commonPrice: undefined,
        discount: {
          isInPercents: true,
          value: 0,
        },
        productList: [],
        servicePaymentAmount: {
          isInPercents: true,
          value: 0,
        },
      };
    })

    //Reducer of set cart
    .addCase(dOrdersSetCartItemAC, (state, action) => {
      state.newOrder = {
        discount: action.payload.discount,
        productList: action.payload.orderedProducts,
        servicePaymentAmount: action.payload.servicePayment,
      };
    })

    //Reducer of set discount
    .addCase(dOrdersSetDiscountInCartItemAC, (state, action) => {
      state.newOrder = state.newOrder
        ? {
            ...state.newOrder,
            discount: {
              isInPercents: action.payload.isPercent,
              value: action.payload.value,
            },
          }
        : {
            productList: [],
            discount: {
              isInPercents: action.payload.isPercent,
              value: action.payload.value,
            },
          };
    })

    //Reducer of set discount
    .addCase(dOrdersSetServicePaymentInCartItemAC, (state, action) => {
      state.newOrder = state.newOrder
        ? {
            ...state.newOrder,
            servicePaymentAmount: {
              isInPercents: action.payload.isPercent,
              value: action.payload.value,
            },
          }
        : {
            productList: [],
            servicePaymentAmount: {
              isInPercents: action.payload.isPercent,
              value: action.payload.value,
            },
          };
    })

    // Reducer of clear state
    .addCase(logoutAC, (state) => {
      state.data = initialState.data;
      state.detailItem = initialState.detailItem;
      state.detailItemFull = initialState.detailItemFull;
      state.filters = initialState.filters;
      state.pagination = initialState.pagination;
      state.productsPagination = initialState.productsPagination;
      state.filteredProductList = initialState.filteredProductList;
      state.productsFilter = initialState.productsFilter;
      state.detailProduct = initialState.detailProduct;
      state.newOrder = initialState.newOrder;
      state.selectedStore = initialState.selectedStore;
    })

    .addCase(resetReducers, (state, action) => {
      if (action.payload !== "orders") {
        state.data = initialState.data;
        state.detailItem = initialState.detailItem;
        state.detailItemFull = initialState.detailItemFull;
        state.filters = initialState.filters;
        state.pagination = initialState.pagination;
        state.productsPagination = initialState.productsPagination;
        state.filteredProductList = initialState.filteredProductList;
        state.productsFilter = initialState.productsFilter;
        state.detailProduct = initialState.detailProduct;
        state.newOrder = initialState.newOrder;
        state.selectedStore = initialState.selectedStore;
      }
    });
});
